export default __webpack_public_path__ + "static/media/Campaign.1d626c88.svg";